module.exports = __webpack_public_path__ + "static/img/4.b443d43.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/eng/4.png
// module id = +mCs
// module chunks = 0